<script lang="ts">
	import { onMount, onDestroy, tick } from "svelte";

	import { fly, fade } from "svelte/transition";
	import Fa from "svelte-fa";
	import { faUser } from "@fortawesome/free-regular-svg-icons";
	import Logo from "./Logo.svelte";
	import Livewire from "./live/Livewire.svelte";
	import Generator from "./live/Generator.svelte";
	import { goto, yyyy, zzzz } from "./store.svelte";
	import { toast } from "./lib/toast.svelte.ts";
	import { captureCardPositions, animateCardTransitions, initializeCardAnimations } from "./lib/flipAnimation";

	import {
		faTimes,
		faChevronUp,
		faChevronDown,
		faSortAlphaDown,
		faSortAlphaUp,
		faSortNumericDown,
		faSortNumericUp,
		faUsers,
		faCreditCard,
		faCheck,
		faClipboardList,
	} from "@fortawesome/free-solid-svg-icons";

	import go2BookMark from "./extras/go2BookMark.svelte";
	import signOut from "./extras/signOut.svelte";
	import getlivewires from "./extras/getlivewires.svelte";
	import { addOnsData } from "./lib/addOnsData";

	// Filter for active addons
	$: activeAddons = addOnsData.filter(addon => addon.readyForAction && addon.id !== 'livewire');

	let ready: boolean = false;
	const url: string = yyyy.uri.api;
	let timey: number;

	let newpass_a: string;
	let newpass_b: string;
	let newpass_aBOX: HTMLInputElement;
	let newpass_bBOX: HTMLInputElement;
	let currentpass: string;
	let currentpassBox: HTMLInputElement;
	let isdanger: boolean;
	let showChange: boolean = false;
	let changeInProgress: boolean = false;
	let showMenu: boolean = false;
	let menuSectionsEl: HTMLElement;
	// Sorting functions that update store and call getlivewires
	let sortLivewiresAZ = async () => {
		const oldPositions = captureCardPositions();
		yyyy.livewire_sortorder = "a-z";
		await getlivewires();
		await tick();
		await animateCardTransitions(oldPositions);
		toggleMenu();
	};

	let sortLivewiresZA = async () => {
		const oldPositions = captureCardPositions();
		yyyy.livewire_sortorder = "z-a";
		await getlivewires();
		await tick();
		await animateCardTransitions(oldPositions);
		toggleMenu();
	};

	let sortLivewiresNewest = async () => {
		const oldPositions = captureCardPositions();
		yyyy.livewire_sortorder = "newest";
		await getlivewires();
		await tick();
		await animateCardTransitions(oldPositions);
		toggleMenu();
	};

	let sortLivewiresOldest = async () => {
		const oldPositions = captureCardPositions();
		yyyy.livewire_sortorder = "oldest";
		await getlivewires();
		await tick();
		await animateCardTransitions(oldPositions);
		toggleMenu();
	};

	let kingston21 = () => {
		console.log("kingston 21");
	};

	// let signOut = () => {
	// 	yyyy.sesh = {};
	// 	yyyy.livewires = [];
	// 	zzzz.emit("goto", "/");
	// 	return true;
	// };

	let createNewLiveWire = () => {
		goto("/create-new-livewire");
	};

	let userManager = () => {
		// Check if user is admin
		if (!yyyy.sesh.tokeninfo?.userinfo?.admin) {
			toast.error("You must be an admin user to access this feature.");
			return;
		}
		console.log("helped");
		goto("/user-manager");
		//ready = !ready;
	};

	let riskPredictor = () => {
		// Check if user has RP addon access
		const userAllowedApps = yyyy.sesh.tokeninfo?.userinfo?.allowedApps || [];
		
		if (!userAllowedApps.includes('rp')) {
			toast.warning("You need access to the Risk Predictor addon to use this feature.");
			return;
		}
		goto("/risk-predictor");
	};

	let toggleMenu = () => {
		showMenu = !showMenu;
		// Close password modal if open
		if (showChange) {
			showChange = false;
		}
	};

	// Reactive statement to scroll to top when menu opens
	$: if (showMenu && menuSectionsEl) {
		menuSectionsEl.scrollTop = 0;
	}

	let togglePasswordChange = async () => {
		showChange = !showChange;
		showMenu = false; // Close menu when opening password modal
		await tick(); // Wait until the DOM has been updated
		if (showChange && currentpassBox) {
			currentpassBox.focus(); // Focus the input after it's revealed
		}
	};

	let passwordChange = async () => {
		changeInProgress = !changeInProgress;
		let _hdrs = {
			"Content-Type": "application/json",
			Authorization: "Bearer " + yyyy.sesh.logtoken.token,
		};
		let _body = JSON.stringify({
			email: yyyy.sesh.tokeninfo.email,
			pass: currentpass,
			new_pass: newpass_a,
		});
		let fetchopts = { method: "post", body: _body, headers: _hdrs };
		const response = await fetch(`${url}/rpc/password`, fetchopts);
		console.log(response);
		if (response.ok) {
			let resp = await response.json();
			console.log("------------");
			console.log(resp);
			console.log("------------");
			let toast_message = {
				message: "Password changed",
				type: "is-success",
				dismissible: false,
				duration: 6500,
				position: "bottom-right",
			};
			zzzz.emit("toast", toast_message);
			showChange = !showChange;
		} else {
			console.log("???");

			let toast_message = {
				message: "You may have enterd the wrong password",
				type: "is-danger",
				dismissible: false,
				duration: 6500,
				position: "bottom-right",
			};
			zzzz.emit("toast", toast_message);
		}
		currentpass = "";
		newpass_a = "";
		newpass_b = "";
		changeInProgress = !changeInProgress;
	};

	onMount(() => {
		if (yyyy.params && yyyy.params.has("b") && yyyy.sesh.logtoken) {
			go2BookMark(yyyy.params.get("b"));
		}
		if (!yyyy.sesh.logtoken) {
			goto("/");
			return;
		}
		setTimeout(() => {
			ready = true;
			yyyy.logo.usage = "logo";
		}, 400);

		// Initialize FLIP animation styles
		initializeCardAnimations();

		timey = setInterval(() => {
			getlivewires();
		}, 11000);

		zzzz.on("getlivewires", () => {
			getlivewires();
		});
	});

	onDestroy(() => {
		clearInterval(timey);
	});
</script>

<!-- <div id="menu"><Logo usage="wait" interact={false} /></div> -->

<!-- <svelte:window on:pushstate={routing} /> -->
<div id="Usercard" class="column is-one-quarter porridge">
	<div class="card lvwr-card" class:zeroBG={!ready}>
		<div class="card-content lvwr-card-content">
			<h1 class="title thin lvwr-title" class:dim={!ready} class:bri={ready}>
				Livewire
			</h1>
			<h2 class="subtitle lvwr-subtitle" class:dim={!ready} class:bri={ready}>
				Power Delivery Modelling in the Cloud by
			</h2>
			<div class="content lvwr-content">
				<Logo usage="logo" interact={false} />
			</div>
			<div class="content lvwr-content" class:dim={!ready} class:bri={ready}>
				<button
					class="button lvwr-toggle-orange is-fullwidth"
					onclick={createNewLiveWire}
				>
					Create new Livewire
				</button>
				<hr />
				<button
					class="button lvwr-toggle-orange is-fullwidth"
					onclick={() => goto("/scope-manager")}
				>
					Manage Scopes
				</button>
			</div>

			<!-- Menu overlay that slides up -->
			<div class="menu-container" class:menu-visible={showMenu}>
				<div class="menu-header">
					<h3 class="menu-title">Menu</h3>
				</div>

				<div class="menu-sections" bind:this={menuSectionsEl}>
					<div class="menu-section">
						<div class="menu-section">
							<h4 class="menu-section-title">Sort Livewires</h4>
							<button class="menu-item" onclick={sortLivewiresAZ}>
								<Fa icon={faSortAlphaDown} />
								<span>Sort A → Z</span>
								{#if yyyy.livewire_sortorder === 'a-z'}
									<Fa icon={faCheck} style="color: #ff3e00;" />
								{/if}
							</button>
							<button class="menu-item" onclick={sortLivewiresZA}>
								<Fa icon={faSortAlphaUp} />
								<span>Sort Z → A</span>
								{#if yyyy.livewire_sortorder === 'z-a'}
									<Fa icon={faCheck} style="color: #ff3e00;" />
								{/if}
							</button>
							<button class="menu-item" onclick={sortLivewiresNewest}>
								<Fa icon={faSortNumericDown} />
								<span>Newest First</span>
								{#if yyyy.livewire_sortorder === 'newest'}
									<Fa icon={faCheck} style="color: #ff3e00;" />
								{/if}
							</button>
							<button class="menu-item" onclick={sortLivewiresOldest}>
								<Fa icon={faSortNumericUp} />
								<span>Oldest First</span>
								{#if yyyy.livewire_sortorder === 'oldest'}
									<Fa icon={faCheck} style="color: #ff3e00;" />
								{/if}
							</button>
						</div>

						<div class="menu-section">
							<h4 class="menu-section-title">Extensions</h4>

							{#each activeAddons as addon}
								<button
									class="menu-item addon-item"
									onclick={() => {
										toggleMenu();
										if (addon.id === 'rp') {
											riskPredictor();
										} else {
											toast.warning("These extensions have not been activated, contact your admin.");
										}
									}}
									title={addon.title}
								>
									<span>{addon.name}</span>
								</button>
							{/each}
						</div>
						<div class="menu-section">
						<h4 class="menu-section-title">Account</h4>
						<button class="menu-item" onclick={togglePasswordChange}>
							<Fa icon={faUser} size="sm" />
							<span>Change Password</span>
						</button>
						<button
							class="menu-item"
							onclick={() => {
								toggleMenu();
								userManager();
							}}
						>
							<Fa icon={faUsers} size="sm" />
							<span>Manage Users</span>
						</button>
						{#if yyyy.features?.triageAnnotations}
						<button
							class="menu-item"
							onclick={() => {
								toggleMenu();
								goto("/triage");
							}}
						>
							<Fa icon={faClipboardList} size="sm" />
							<span>Triage Annotations</span>
						</button>
						{/if}
						<button
							class="menu-item"
							onclick={() => {
								toggleMenu();
								if (!yyyy.sesh.tokeninfo?.userinfo?.admin) {
									toast.warning("You must be an admin user to access billing.");
									return;
								}
								goto("/billing");
							}}
						>
							<Fa icon={faCreditCard} size="sm" />
							<span>Billing</span>
						</button>
					</div>

					<div class="menu-section">
						<h4 class="menu-section-title">Help</h4>
						<button
							class="menu-item"
							onclick={() => {
								toggleMenu();
								zzzz.emit("start-help-tour");
							}}
						>
							<span>Help Tour</span>
						</button>
					</div>
				</div>
			</div>
		</div>
		</div>
		<footer class="card-footer" class:dim={!ready} class:bri={ready}>
			<div class="card-footer-item sign-in-up-footer">
				<button
					onclick={signOut}
					class="button lvwr-toggle-cancel"
					class:menu-hidden={showMenu}
					disabled={showMenu}>Sign-Out</button
				>
				<button onclick={toggleMenu} class="button lvwr-toggle-orange" title="Menu"
					><Fa icon={showMenu ? faChevronDown : faChevronUp} />
				</button>
			</div>
		</footer>
	</div>
</div>

{#if yyyy.livewires}
	{#each yyyy.livewires.filter((lw: any) => !yyyy.livewireFilter || lw.livewire?.toLowerCase().includes(yyyy.livewireFilter)) as lw, i}
		{#if lw.isready}
			<Livewire {...lw} index={i} />
		{:else}
			<Generator {...lw} index={i} />
		{/if}
	{:else}
		{#if !yyyy.livewireFilter}
			<div
				transition:fly|local={{ y: 20000 }}
				class="column is-one-quarter porridge"
			>
				<div class="card" class:zeroBG={!ready}>
					<div class="card-content">
						<h1 class="title" class:dim={!ready} class:bri={ready}>Hey!!!!</h1>
						<div class:dim={!ready} class="content lvwr-io-button">
							Welcome, it looks like you are new to the livewire family!!! <br />If you
							have data, and are ready to go, click the "Create new Livewire" button.
							<br />If you do not have any data, we can get you started on an electric
							distribution network called "Kingston 21". Click the "Create Kingston 21"
							button below. This will generate the livewire for you so you can start
							exploring.
						</div>
						<div class="content lvwr-content" class:dim={!ready} class:bri={ready}>
							<button
								class="button lvwr-toggle-outlined is-fullwidth"
								onclick={kingston21}
							>
								Create Kingston 21 Livewire
							</button>
						</div>
					</div>
				</div>
			</div>
		{/if}
	{/each}
{/if}

{#if showChange}
	<div id="changer-backdrop" transition:fade={{ duration: 1000 }}></div>
	<div
		transition:fly|local={{ y: -250, delay: 175 }}
		id="password-changer"
		class:expanded={yyyy.map.menu}
		class:expanded-for-info={yyyy.map.info}
	>
		<button id="closer" onclick={togglePasswordChange}>
			<Fa icon={faTimes} size="1.75x" />
		</button>

		<div class="user-info">
			<h4>Change Password for:</h4>
			<p class="user-email">{yyyy.sesh.tokeninfo?.email || "Loading..."}</p>
		</div>

		<div class="field">
			<label class="label" for="email">Current Password</label>
			<div class="control">
				<input
					id="currentpasss"
					class="input"
					type="password"
					placeholder="Enter your current password"
					bind:value={currentpass}
					bind:this={currentpassBox}
				/>
			</div>
		</div>

		<div class="field">
			<label class="label" for="email">Enter new Password</label>
			<div class="control">
				<input
					id="newpassword-a"
					class="input"
					type="password"
					placeholder="Enter your new password"
					bind:value={newpass_a}
					bind:this={newpass_aBOX}
				/>
			</div>
		</div>
		<div class="field">
			<label class="label" for="email">Confirm new password</label>
			<div class="control">
				<input
					id="newpassword-b"
					class="input"
					type="password"
					placeholder="Confirm your new password                    "
					bind:value={newpass_b}
					bind:this={newpass_bBOX}
				/>
			</div>
		</div>
		<button
			class="button lvwr-toggle is-fullwidth"
			onclick={passwordChange}
			class:is-loading={changeInProgress}
			disabled={!newpass_a ||
				!newpass_b ||
				!currentpass ||
				newpass_b !== newpass_a}>Change Password</button
		>
	</div>
{/if}

<style>
	.porridge {
		width: 375px;
	}

	.lvwr-card-content {
		height: 410px;
		padding: 1em;
	}
	.porridge {
		width: 375px;
	}
	/*
  .card-content {
    height: 410px;
  }
*/
	.sign-in-up-footer {
		justify-content: space-between;
	}

	.button.menu-hidden {
		opacity: 0;
		pointer-events: none;
	}

	.zeroBG {
		background-color: #fff0;
		box-shadow: none;
		transition: background-color 2.5s ease;
	}

	.dim {
		opacity: 0%;
		transition: opacity 2.5s ease;
	}

	.bri {
		opacity: 100%;
		transition: opacity 2.5s ease;
	}

	/* #btngrp { justify-content: space-between} */
	#password-changer {
		position: fixed;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		left: 50%;
		top: 50%;
		background-color: #ffffffe0;
		padding-left: 8.775px;
		padding-right: 8.775px;
		padding-top: 8.775px;
		padding-bottom: 8.775px;
		border-radius: 8.775px;
		backdrop-filter: blur(0.8775px) grayscale(0.8775);
		transition:
			height 0.3s ease,
			padding-top 0.3s ease;
		transform: translateX(-50%) translateY(-50%);
	}
	#closer {
		color: #ff3e00;
		position: absolute;
		top: 8.775px;
		right: 8.775px;
	}
	#changer-backdrop {
		position: fixed;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		backdrop-filter: grayscale(1) blur(2px) brightness(25%);
	}

	.user-info {
		text-align: center;
		margin-bottom: 1rem;
		padding-bottom: 0.5rem;
		border-bottom: 1px solid #eee;
	}

	.user-info h4 {
		margin: 0 0 0.5rem 0;
		font-size: 1rem;
		color: #363636;
		font-weight: 500;
	}

	.user-email {
		margin: 0;
		font-size: 0.9rem;
		color: #ff3e00;
		font-weight: 600;
	}

	input {
		cursor: #ff3e00;
		caret-color: #ff3e00;
		caret-shape: block;
	}

	#menu {
		position: absolute;
		z-index: 500000;
		top: 2svh;
		left: 2svw;
		width: 200px;
	}

	/* Menu Styles (overlay in card) */
	.lvwr-card-content {
		position: relative;
		overflow: hidden;
	}

	.menu-container {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: #ffffffe0;
		backdrop-filter: blur(10px);
		display: flex;
		flex-direction: column;
		padding: 1em;
		transform: translateY(100%);
		transition: transform 0.3s ease-out;
	}

	.menu-container.menu-visible {
		transform: translateY(0);
	}

	.menu-header {
		padding-bottom: 1rem;
		border-bottom: 1px solid #eee;
		margin-bottom: 1rem;
	}

	.menu-title {
		font-size: 1.25rem;
		font-weight: 600;
		color: #ff3e00;
		margin: 0;
	}

	.menu-sections {
		flex: 1;
		overflow-y: auto;
	}

	.menu-section {
		margin-bottom: 1.25rem;
	}

	.menu-section-title {
		font-size: 0.75rem;
		font-weight: 600;
		color: #999;
		text-transform: uppercase;
		letter-spacing: 0.05em;
		margin-bottom: 0.5rem;
	}

	.menu-item {
		display: flex;
		align-items: center;
		gap: 0.5rem;
		width: 100%;
		padding: 0.5rem 0.75rem;
		background: none;
		border: none;
		border-radius: 6px;
		cursor: pointer;
		transition: all 0.2s;
		text-align: left;
		font-size: 0.95rem;
		color: #363636;
		margin-bottom: 0.25rem;
	}

	.menu-item:hover {
		background-color: rgba(255, 62, 0, 0.1);
	}

	.menu-item span {
		flex: 1;
	}

	.addon-item {
		position: relative;
	}

	.addon-item:hover {
		background-color: rgba(255, 62, 0, 0.15);
	}
</style>
